module.exports = __webpack_public_path__ + "img/map-message-2.f7241daf.png";